import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import SliderFilter from './SliderFilter/SliderFilter.tsx'


export const Container = styled.div`
  padding:0 0 20px 0;
  & .contentSection{
       margin: 0 8px;
  }
  @media (max-width: 768px) {
     padding: 0
   }
`;
//  select tag 
export const SelectTag = styled.div`
   background: #2276E3;
   padding: 8px;
   border-radius: 2px;
   font-size: 14px;
   font-family: Quicksand;
   display: inline-flex;
   color: #fff;
   align-items: center;
   margin-left: -5px;
  
`;
export const SelectDateWrapper = styled.div`
   display: flex;
   align-items: center;
   & .arrowIcon{
     width: 15px; 
     height: 13px;
}`;
//  female discount section 

export const DiscountTag = styled.div`
     background: #D1E5FF;
     padding: 4px 5px;
     border-radius: 2px;
     font-size: 11px;
     color: #141823;
     & .bold{
          font-weight: 700;
     }
`;

export const DiscountPersuation = styled.div`
     background: #D1E5FF;
     border-radius: 4px;
     padding: 12px 18px;
     display: flex;
     align-items: center;
     & .femaleIcon{
          width: 36px;
          height: 36px;
          margin-right: 14px;
     }
     & span{
          font-size: 18px;
          color: #141823;
          line-height: 22px;
          & .bold{
               font-weight: 700
          }
     }

`

const TopFilterCards = (props) => {

  return (
       <>
    <Container>

     <SliderFilter filter_cards={props.filter_cards} onFilterCardClick={props.onFilterCardClick} />
    </Container>
     <div>
     </div>
    </>
  );
};

export default TopFilterCards;
